import { PolygonThemeSetting } from '@bpd-library/types';

const geojson = (map: mapboxgl.Map, setting: PolygonThemeSetting) => {
    map.addSource(setting.variant, {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] },
        promoteId: 'id',
    });
};

export default geojson;
